import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, GerarBoletoAgrupado } from './types';

export const INITIAL_STATE: GerarBoletoAgrupado = {
	status: 0,
	data: null,
	form: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): GerarBoletoAgrupado {
	return produce(state, draft => {
		switch (action.type) {
			case Types.GERAR_BOLETO_AGRUPADO_REQUEST: {
				draft.form = action.payload;
				break;
			}
			case Types.GERAR_BOLETO_AGRUPADO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.GERAR_BOLETO_AGRUPADO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.GERAR_BOLETO_AGRUPADO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.form = INITIAL_STATE.form;
				break;
			}

			default:
		}

		return draft;
	});
}
